"use client";
import {
  useStore,
  useStoreProps
} from "./2ID5JPOO.js";
import {
  useUpdateEffect
} from "./6WEF4WY5.js";

// src/checkbox/checkbox-store.ts
import * as Core from "@ariakit/core/checkbox/checkbox-store";
function useCheckboxStoreProps(store, update, props) {
  useUpdateEffect(update, [props.store]);
  useStoreProps(store, props, "value", "setValue");
  return store;
}
function useCheckboxStore(props = {}) {
  const [store, update] = useStore(Core.createCheckboxStore, props);
  return useCheckboxStoreProps(store, update, props);
}

export {
  useCheckboxStoreProps,
  useCheckboxStore
};
